import { render, staticRenderFns } from "./AggregatedKpis.vue?vue&type=template&id=7c2baffa&scoped=true"
import script from "./AggregatedKpis.vue?vue&type=script&lang=js"
export * from "./AggregatedKpis.vue?vue&type=script&lang=js"
import style0 from "./AggregatedKpis.vue?vue&type=style&index=0&id=7c2baffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2baffa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxMetricBox: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/MetricBox.vue').default})
